import { useState, useEffect } from 'react';

function Header() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header 
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 bg-white ${
        isScrolled ? 'shadow-md py-3' : 'py-4'
      }`}
    >
      <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div className="flex items-center">
            <a href="#home" className="flex items-center">
              <img 
                src="/logo.png" 
                alt="Cash Tec Logo" 
                className="h-12 md:h-16 lg:h-20 transition-all duration-300"
              />
            </a>
          </div>

          {/* Navigation Links – تسويقية وواضحة */}
          <div className="hidden md:flex items-center space-x-reverse space-x-6 lg:space-x-8">
            <a href="#home" className="flex items-center"></a>
            <a 
              href="#solutions" 
              className="transition-colors duration-300 font-medium text-gray-700 hover:text-primary-500"
            >
              حلولنا
            </a>
            <a 
              href="#management" 
              className="transition-colors duration-300 font-medium text-gray-700 hover:text-primary-500"
            >
              إدارة الأعمال
            </a>
            <a 
              href="#products" 
              className="transition-colors duration-300 font-medium text-gray-700 hover:text-primary-500"
            >
              المنتجات
            </a>
            <a 
              href="#features" 
              className="transition-colors duration-300 font-medium text-gray-700 hover:text-primary-500"
            >
              المميزات
            </a>
            <a 
              href="#contact" 
              className="transition-colors duration-300 font-medium text-gray-700 hover:text-primary-500"
            >
              تواصل معنا
            </a>
          </div>

          {/* CTA Button */}
          <a 
            href="https://wa.me/966557990109"
            target="_blank"
            rel="noopener noreferrer"
            className="px-6 py-2 rounded-full font-semibold transition-all duration-300 bg-primary-500 text-white hover:bg-primary-600"
          >
            ابدأ الآن
          </a>

          {/* Mobile Menu Button */}
          <button 
            className="md:hidden p-2 rounded-lg transition-colors duration-300 text-gray-700"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
        </div>
      </nav>
    </header>
  );
}

export default Header;
